import { Outlet } from "react-router-dom";

const Reportes = () => {
  return (
    <div style={{ marginTop: "70px" }}>
      <Outlet />
    </div>
  );
};

export default Reportes;
